module.exports = __webpack_public_path__ + "static/media/door02.65a28930.png";